const whitePages = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/login',
        component: () => import('@/pages/login/index.vue'),
    },
    {
        path: '/home',
        component: () => import('@/pages/home/index.vue'),
    },
    {
        path: '/userinfo',
        component: () => import('@/pages/home/userinfo.vue'),
    },
    {
        path: '/print/index',
        component: () => import('@/pages/print/index.vue'),
    },
    {
        path: '/404',
        component: () => import('@/pages/404.vue'),
    },
];
export default whitePages;
